// src/config.js — Central configuration for brand constants
// Edit this file to update phone numbers, links, and brand info across the whole site.

export const BRAND = {
  name:        "DG HelpMate",
  tagline:     "India's #1 Content Studio for Coaching Institutes",
  phone:       "9241653369",
  phoneE164:   "+919241653369",
  whatsapp:    "919241653369",
  email:       "support@dghelpmate.com",
  website:     "https://dghelpmate.com",
  instagram:   "https://instagram.com/dghelpmate",
  youtube:     "https://youtube.com/@dghelpmate",
};

/** Canonical public site (admin tools, emails, share links) */
export const LIVE_SITE_URL = BRAND.website;

// Live WhatsApp number — updated from Firestore by useSiteContent on load
let _liveWA = BRAND.whatsapp;
export const setLiveWhatsapp = (num) => { if (num && /^\d{10,15}$/.test(num.replace(/\D/g, ""))) _liveWA = num.replace(/\D/g, ""); };
export const WA_URL = (msg = "") =>
  `https://wa.me/${_liveWA}${msg ? `?text=${encodeURIComponent(msg)}` : ""}`;
